import React from "react";
import styles from "./FranchiseTableControls.module.css";
import {BroomButton} from "../../../../elements/broomButton/BroomButton";
import {SearchField} from "../../../../elements/searchField/SearchField";
import {
    MultiSelectTableFilterDropdown
} from "../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    defaultFranchiseTableRequest,
    franchiseLocationOptionsSelector,
    franchiseTableRequestSelector,
    resetFranchiseTableRequest,
    updateFranchiseTableRequest
} from "../../franchiseSlice";
import {SelectOption} from "../../../../elements/select/SelectDropdown";

export const FranchiseTableControls: React.FC = () => {
    const dispatch = useAppDispatch();
    const locations = useAppSelector(franchiseLocationOptionsSelector);
    const tableRequest = useAppSelector(franchiseTableRequestSelector);

    const locationOptions: SelectOption<string>[] = locations
        .filter(location => !!location.publicId)
        .map(location => ({
            value: location.publicId as string,
            label: location.locationName || location.publicId as string
        }));

    const resetFilters = () => {
        if (tableRequest.searchQuery !== defaultFranchiseTableRequest.searchQuery ||
            tableRequest.locationPublicIds !== defaultFranchiseTableRequest.locationPublicIds) {
            dispatch(resetFranchiseTableRequest());
        }
    };

    return <div className={styles.wrapper}>
        <div className={styles.controls}>
            <SearchField
                value={tableRequest.searchQuery}
                placeholder={"Search Name, Hash, URL Pattern"}
                onChange={searchQuery => dispatch(updateFranchiseTableRequest({searchQuery}))}
            />
            <MultiSelectTableFilterDropdown<string, {}>
                value={tableRequest.locationPublicIds}
                placeholder={"Filter by Location"}
                width={500}
                handleChange={locationPublicIds => dispatch(updateFranchiseTableRequest({locationPublicIds}))}
                options={locationOptions}
            />
        </div>
        <div className={styles.clearButton}>
            <BroomButton disabled={false} handleClick={resetFilters}/>
        </div>
    </div>;
};
